export const DISNEY_SELECTION_MODAL_TEST_ID = {
    MODAL: 'disney-selection-modal',
    DISNEY_STANDARD_BUTTON: 'disney-selection-modal-standard-button',
    DISNEY_PREMIUM_BUTTON: 'disney-selection-modal-premium-button',
};
